import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { Observable } from 'rxjs';

@Injectable()
export class AttendanceService {
  constructor(private settings: SettingService,
              private http: HttpClient) {
  }
  api = 'school-program-http/api/v1';
  activityName: any;

  saveAttendanceData(id: number, param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/attendance-update/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/attendance-update/' + id;

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  getActivityAttendanceList(id: number, param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/attendance-list/' + id;
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/attendance-list/' + id;

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  getActivitySessionList(param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/session-list';
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/session-list';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  toggleDisableSession(param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/session-disable';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/session-disable';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  entrySessionAttendance(param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/attendance-create';
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/attendance-create';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  newEntrySessionAttendance(param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/attendance-create';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/attendance-create-new';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

  attendanceTemplate(id: number): Observable<Blob> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + `/generate-attendance-template/${id}?activityName=${encodeURIComponent(this.activityName)}`;
    // const requestUrl = `http://localhost:3073/school-program-http/api/v1/generate-attendance-template/${id}?activityName=${encodeURIComponent(this.activityName)}`;

    // return this.http.get<Blob>(requestUrl, {headers: this.settings.httpOptionWithToken().headers.set(
    //   'Accept',
    //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    // ), responseType: 'blob' as 'json'}); 
    return this.http.get<any>(requestUrl, {
      ...this.settings.httpOptionWithSession(),
      responseType: 'blob' as 'json',
    }); 
  }

  uploadAttendance(param: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/upload-attendance';
    // const requestUrl = 'http://localhost:3073/school-program-http/api/v1/upload-attendance';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(param)), this.settings.httpOptionWithSession());
  }

}
